import {
    PROFILE_CENTER_LOAD_INFO_REQUEST,
    PROFILE_CENTER_LOAD_INFO_SUCCESS,

    PROFILE_CENTER_UNREGISTERE_ROOM_CONFIG_REQUEST,
    PROFILE_CENTER_UNREGISTERE_ROOM_CONFIG_SUCCESS,
} from '../../types'

const initialState = {}
export default {
    profileCenterInfo: (state = initialState, action) => {
        switch (action.type) {
            case PROFILE_CENTER_LOAD_INFO_REQUEST:
                return initialState
            case PROFILE_CENTER_LOAD_INFO_SUCCESS:
                return action.payload

            default:
                return state
        }
    },
    profileUpdateStatus: (state = false, action) => {
        switch (action.type) {
            case PROFILE_CENTER_UNREGISTERE_ROOM_CONFIG_REQUEST:
                return initialState
            case PROFILE_CENTER_UNREGISTERE_ROOM_CONFIG_SUCCESS:
                return action.payload

            default:
                return state
        }
    },
}


// WEBPACK FOOTER //
// ./src/features/profilecenter/reducer.js